import React, { Component } from 'react'
import { connect } from 'react-redux';
import Xarrow from 'react-xarrows';

import {
  toggleVisibility,
  closeScreens
} from '../actions/bookPayConfirmActions';

import {
  Button,
  Grid,
  Image,
  Header,
  Modal
} from 'semantic-ui-react'
import BookingScreen from './BookingScreen';
import PaymentScreen from './PaymentScreen';
import ConfirmationScreen from './ConfirmationScreen';
import booking from '../images/booking/booking.svg';
import payment from '../images/booking/payment.svg';
import futurePayment from '../images/booking/futurePayment.svg';
import confirmation from '../images/booking/confirmation.svg';
import futureConfirmation from '../images/booking/futureConfirmation.svg';

class Booking extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loadNow: false,
    };
  }

  getActiveScreen = () => {
    const index = this.props.index;

    switch (this.props.activeScreen) {
      case 1:
        return <PaymentScreen index={index} />;
      case 2:
        return <ConfirmationScreen index={index} parkingLotName={this.props.parkingLotNames[index]} />;
      default:
        return (
          <BookingScreen
            index={index}
            parkingPrice={parseFloat(this.props.parkingPrices[index])}
            parkingLotAddress={this.props.parkingLotAddresses[index]}
            parkingLotName={this.props.parkingLotNames[index]}
          />
        );
    }
  }


  getPaymentStatus = () => {
    if (this.props.activeScreen > 0) {
      return payment;
    } else {
      return futurePayment;
    }
  }

  getConfirmationStatus = () => {
    if (this.props.activeScreen === 2) {
      return confirmation;
    } else {
      return futureConfirmation;
    }
  }

  get12Status = () => {
    if (this.props.activeScreen > 0) {
      return 'black';
    } else {
      return '#EBEBEB';
    }
  }

  get23Status = () => {
    if (this.props.activeScreen === 2) {
      return 'black';
    } else {
      return '#EBEBEB';
    }
  }

  render() {
    return (
      <Modal
        closeIcon
        onClose={() => { this.props.toggleVisibility(1) }}
        onMount={() => {
          setTimeout(() => {
            this.setState({
              loadNow: true,
            });
          }, 100);

        }
        }
        open={this.props.screensVisible && this.props.visible}
        trigger={
          <Button disabled={this.props.screensVisible}
            content={'Parkplatz buchen'}
            onClick={() => {
              this.props.toggleVisibility(this.props.screensVisible);
            }}
            color='black'
            size='huge'

          />
        }
      >
        <Modal.Header>
          <Grid>
            <Grid.Row columns='equal'>
              <Grid.Column textAlign='center'>
                <Image id='bookingStep' src={booking} centered />
                <Header as='h3' content='Buchen' />
              </Grid.Column>
              <Grid.Column textAlign='center'>
                <Image id='payingStep' src={this.getPaymentStatus()} centered />
                <Header as='h3' content='Zahlen' />
              </Grid.Column>
              <Grid.Column textAlign='center'>
                <Image id='confirmingStep' src={this.getConfirmationStatus()} centered />
                <Header as='h3' content='Bestätigen' />
              </Grid.Column>
            </Grid.Row>
          </Grid>
          {
            this.state.loadNow &&
            <>
              <Xarrow start='bookingStep' end='payingStep' color={this.get12Status()} startAnchor='right' endAnchor='left' headSize={0} strokeWidth={6} />
              <Xarrow start='payingStep' end='confirmingStep' color={this.get23Status()} startAnchor='right' endAnchor='left' headSize={0} strokeWidth={6} />
            </>
          }

        </Modal.Header>
        {this.getActiveScreen()}

      </Modal>
    )
  }
}

const mapStateToProps = state => ({
  activeScreen: state.screens.activeScreen,
  screensVisible: state.screens.screensVisible,
  parkingPrices: state.posts.parkingPrices,
  parkingLotNames: state.posts.parkingLotNames,
  parkingLotAddresses: state.posts.parkingLotAddresses,
});

export default connect(mapStateToProps, { closeScreens, toggleVisibility })(Booking)
